import makeStyles from '@mui/styles/makeStyles';
import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';

type TimelineFilterBarProps = {
    title: string;
    options: string[];
    activeFilter: string;
    onFilterChange: (filter: string) => void;
};

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        borderBottom: '1px solid #f1f3f5',
    },
    title: {
        fontSize: 18,
        fontWeight: 600,
        color: '#2c3e50',
        marginBottom: theme.spacing(2),
    },
    filterLabel: {
        fontSize: 13,
        color: '#6c757d',
        fontWeight: 500,
    },
    button: {
        textTransform: 'capitalize',
        fontSize: 13,
    },
    buttonActive: {
        backgroundColor: '#1a8c8c',
        '&:hover': {
            backgroundColor: '#167676',
        },
    },
}));

const TimelineFilterBar: React.FC<TimelineFilterBarProps> = ({ title, options, activeFilter, onFilterChange }) => {
    const classes = useStyles();
    return (
        <Box className={classes.root}>
            <Typography className={classes.title}>{title}</Typography>
            {options.length > 1 && (
                <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
                    <Typography className={classes.filterLabel}>Show:</Typography>
                    {options.map((opt) => (
                        <Button
                            key={opt}
                            size="small"
                            variant={activeFilter === opt ? 'contained' : 'outlined'}
                            className={`${classes.button} ${activeFilter === opt ? classes.buttonActive : ''}`}
                            onClick={() => onFilterChange(opt)}
                        >
                            {opt === 'all' ? 'All Fields' : opt}
                        </Button>
                    ))}
                </Stack>
            )}
        </Box>
    );
};

export default TimelineFilterBar;
